var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("filter-base", {
    attrs: {
      options: _vm.careOptions,
      label: "Cares",
      title: "Care Classifications",
      customText: _vm.selectedText
    },
    on: {
      selectedIDs: function($event) {
        _vm.selectedIDs = $event
      }
    },
    model: {
      value: _vm.careTypes,
      callback: function($$v) {
        _vm.careTypes = $$v
      },
      expression: "careTypes"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }